module.exports = __webpack_public_path__ + "img/logo blauw.e778a7ed.png";